import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CarouselModule, Carousel } from 'primeng/carousel';
import { TagModule } from 'primeng/tag';
import { ApiService } from '../../services/api.service';
import { isPlatformBrowser, NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { UtilService } from '../../services/util.service';
import { TooltipModule } from 'primeng/tooltip';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
// import { PopUpComponent } from '../pop-up/pop-up.component';
// import { ShippingFeesModalComponent } from '../shipping-fees-modal/shipping-fees-modal.component';
// import { HeaderComponent } from '../header/header.component';
import { ProductCardComponent } from '../product-card/product-card.component';
import { FeaturedCarouselComponent } from '../featured-carousel/featured-carousel.component';
@Component({
  selector: 'app-recent-view',
  imports: [
    CarouselModule,
    ButtonModule,
    TagModule,
    NgIf,
    TooltipModule,
    ToastModule,
    FormsModule,
    // PopUpComponent,
    // ShippingFeesModalComponent,
    ProductCardComponent,
    FeaturedCarouselComponent

  ],
  providers: [MessageService],
  templateUrl: './recent-view.component.html',
  styleUrl: './recent-view.component.css',
})
export class RecentViewComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('recentCarousel') recentCarousel!: Carousel;
  feesCart: any;
  debounceTimer: any;
  showCartWarning: boolean = false;
  private resizeHandler = () => this.updateCanScroll();
  recentResponsiveOptions = [
    { breakpoint: '1250px', numVisible: 4, numScroll: 3 },
    { breakpoint: '992px', numVisible: 3, numScroll: 2 },
    { breakpoint: '750px', numVisible: 2, numScroll: 1 },
  ];
  recentlyView: any = [];
  cartList: any = [];
  user: any;
  qty: number = 0;
  warningTimeout: any;
  showEnabled: boolean = false;
  // addedToCart: boolean = false;
  isLogin = false;
  // addedItem: any;
  userSubscription = new Subscription();
  quotesSubscription = new Subscription();
  showQuantityState: {
    [key: string]: {
      visible: boolean;
      locked?: boolean;
    };
  } = {};
  // responsiveOptions: any[] | undefined;
  // @ViewChild(PopUpComponent) popup!: PopUpComponent;
  // @ViewChild(ShippingFeesModalComponent)
  // popupShipFees!: ShippingFeesModalComponent;
  // header = inject(HeaderComponent)
  recentlybought = false;
  frequentlyBought = false;
  canScroll = false;

  /** Homepage marketing variant: only shows for existing customers (recently BOUGHT),
   *  uses the homepage section-title style + the larger Featured-style product cards.
   *  Default (false) keeps the original search-style cards for all other pages. */
  @Input() homepage = false;

  /** Product-detail variant: the slug of the product being viewed. When set, this section
   *  shows "Frequently Bought Together" for that product instead of Recently Bought, and
   *  falls back to Recently Viewed when there are no companions. Unset everywhere else,
   *  which keeps the original bought/viewed behaviour. */
  @Input() boughtTogetherSlug?: string;

  popupData = {
    image: '/images/svg/add-to-cart.svg',
    title: 'Added to cart',
    message: '“You Have Successfully Added This Item To The Cart”',
  };
  // private addTocartSubject = new Subject<any>();
  constructor(
    private api: ApiService,
    private util: UtilService,
    private router: Router,
    private messageService: MessageService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    //  this.addTocartSubject.pipe(debounceTime(1000)).subscribe((cart) => {
    //     this.performAddToCart(cart);
    //   });
  }
  async ngOnInit() {
    // this.responsiveOptions = [
    //   {
    //     breakpoint: '1199px',
    //     numVisible: 1,
    //     numScroll: 1,
    //   },
    //   {
    //     breakpoint: '991px',
    //     numVisible: 2,
    //     numScroll: 1,
    //   },
    //   {
    //     breakpoint: '750px',
    //     numVisible: 1,
    //     numScroll: 1,
    //   },
    // ];
    await this.getRecentlyView();
    this.updateCanScroll();
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('resize', this.resizeHandler);
    }
    this.userSubscription = this.util.user$.subscribe(async (user) => {
      this.user = user;
      const wasLoggedIn = this.isLogin;
      if (this.user?.firstName) {
        this.isLogin = true;
      } else {
        this.isLogin = false;
      }
      if (wasLoggedIn !== this.isLogin) {
        await this.getRecentlyView();
        this.updateCanScroll();
      }
    });

    this.quotesSubscription = this.util.productDetailsFetch.subscribe((res) => {
      if (res?.length) {
        let item = this.recentlyView.findIndex((item: any) => item.urlSlug == res)
        if (item >= 0) {
          this.recentlyView[item].isInQuote = true;
        }
      }
    })
  }

  /** The product-detail page reuses one instance across product navigations and variant
   *  swaps — it drives everything off paramMap, so this component is never torn down and
   *  ngOnInit fires once. Without this the carousel would keep the first product's
   *  companions. The first change is skipped: ngOnInit runs right after it and fetches. */
  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    const change = changes['boughtTogetherSlug'];
    if (!change || change.firstChange || change.currentValue === change.previousValue) return;
    await this.getRecentlyView();
    this.updateCanScroll();
  }

  ngOnDestroy(): void {
    this.recentlyView = null;
    this.quotesSubscription?.unsubscribe()
    this.userSubscription?.unsubscribe()
    if (isPlatformBrowser(this.platformId)) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  }

  private initQuantityState(slug: string) {
    if (!this.showQuantityState[slug]) {
      this.showQuantityState[slug] = { visible: false, locked: false };
    }
    return this.showQuantityState[slug];
  }

  toggleQuantityVisibility(slug: string) {
    const state = this.initQuantityState(slug);
    state.visible = true;
  }
  out(slug: string) {
    const state = this.showQuantityState[slug];
    if (!state) return;

    if (!state.locked) {
      state.visible = false;
    }
  }
  async handleRemove(url: string, product: any) {
    await this.api.removeCart(url);
    this.cartList.items = this.cartList.items.filter((item: any) => item.product.urlSlug !== product.urlSlug);
    this.util.CartUpdated(this.cartList);
  }

  async getRecentlyView() {
    let res;

    this.frequentlyBought = false;

    if (!this.isLogin) {
      try {
        const recentViewsStr = isPlatformBrowser(this.platformId) ? sessionStorage.getItem('recentlyViewed') : null;
        res = recentViewsStr ? JSON.parse(recentViewsStr) : [];
        this.recentlybought = false;
      } catch (error) {
        console.error('Error fetching from session storage:', error);
        res = [];
      }
    } else if (this.boughtTogetherSlug) {
      // Product-detail variant: companions replace Recently Bought entirely. A product
      // nobody has ordered — or only ever ordered alone — has none, and a failed call must
      // not cost the page its bottom section, so both fall through to Recently Viewed.
      let companions: any[] = [];
      try {
        const data = await this.api.getBoughtTogether(this.boughtTogetherSlug);
        companions = data?.products ?? [];
      } catch (error) {
        console.error('Error fetching frequently bought together:', error);
      }
      if (companions.length) {
        this.frequentlyBought = true;
        this.recentlybought = false;
        res = companions;
      } else {
        this.recentlybought = false;
        res = await this.api.getRecentlyViewed();
      }
    } else {
      let data = await this.api.getRecentlyBought()
      if (data) {
        this.recentlybought = true;
        res = data;
      } else {
        this.recentlybought = false;
        res = await this.api.getRecentlyViewed();
      }
    }

    this.recentlyView = (res ?? []).map((data: any, index: number) => {
      if (data.cartQty == null) data.cartQty = 0;
      return { ...data, _idx: index };
    });
  }
  isItemInCompareList(item: any): boolean {
    if (!isPlatformBrowser(this.platformId)) return false;
    const compareList = JSON.parse(localStorage.getItem('compareList') || '[]');
    return compareList.some((i: any) => i.productName === item.productName);
  }
  async onClickCompare(item: any) {
    if (!isPlatformBrowser(this.platformId)) return;
    const compareList = JSON.parse(localStorage.getItem('compareList') || '[]');
    const existingIndex = compareList.findIndex(
      (i: any) => i.productName === item.productName
    );
    if (existingIndex !== -1) {
      compareList.splice(existingIndex, 1);
      localStorage.setItem('compareList', JSON.stringify(compareList));
      this.messageService.add({
        severity: 'info',
        summary: 'Removed',
        detail: `Item removed from compare list`,
        life: 2000,
      });
    } else {
      compareList.push(item);
      localStorage.setItem('compareList', JSON.stringify(compareList));
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: `Item added to compare list`,
        life: 2000,
      });
    }
  }

  updateCanScroll() {
    if (!isPlatformBrowser(this.platformId) || !this.recentlyView?.length) {
      this.canScroll = false;
      return;
    }
    const width = window.innerWidth;
    let numVisible = 5;
    for (const opt of this.recentResponsiveOptions) {
      if (width <= parseInt(opt.breakpoint, 10)) {
        numVisible = opt.numVisible;
      }
    }
    this.canScroll = this.recentlyView.length > numVisible;
  }

  navigateToProduct(slug: any) {
    this.router.navigateByUrl(`product/${slug}`);
  }

  //  closeAddtocart() {
  //   this.addedToCart = false;
  //   this.addedItem = null;
  //   this.util.setBackdrop(false);
  //   this.showEnabled = false;
  // }
  // openAddtocart(product: any) {
  //   if (!this.showEnabled) return;
  //   this.addedItem = product;
  //   this.addedToCart = true;
  //   this.util.setBackdrop(true);
  //   this.showEnabled = false;
  // }
}
